import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { RootState } from '../../../../store/store';
import { BillingTableRow } from './components/BillingTableRow/BillingTableRow';
import { CompleteOrderModal } from './components/CompleteOrderModal/CompleteOrderModal';
import { ManageSubscriptionModal } from './components/ManageSubscriptionModal/ManageSubscriptionModal';

export const GeneralBilling: React.FC = (): JSX.Element => {
  const { org } = useSelector((state: RootState) => state.auth);

  const [subscriptionModalOpen, setSubscriptionModalOpen] = useState(false);

  const toggleSubscriptionModal = () => {
    setSubscriptionModalOpen(!subscriptionModalOpen);
  };

  const isNavigationDisabledCheck =
    typeof org?.isFunctionalityEnabled === 'boolean' &&
    !org.isFunctionalityEnabled;

  // const todays = moment();

  // const endDates = moment(org?.subscription?.trialEnd);

  // const daysLefts = endDates.diff(todays, 'days');

  // const todayForm = moment().format('YYYY-MM-DD');

  // const endDateForm = moment(org?.subscription?.trialEnd).format('YYYY-MM-DD');

  // const isTodayBeforeEndDates = endDates.diff(todays, 'days') >= 0;

  // console.log(daysLefts, todayForm, endDateForm, isTodayBeforeEndDates);

  const defineNoticeDateMessage = () => {
    let message = '';

    // console.log(org?.subscription?.trialEnd, 'IN HEAD OF FUNCTION');

    if (org?.subscription?.trialEnd) {
      const today = moment();

      const endDate = moment(org?.subscription?.trialEnd);

      const isTodayBeforeEndDate = endDate.diff(today, 'days') >= 0;

      const daysLeft = endDate.diff(today, 'days');

      // console.log(
      //   today.format('MMMM DD HH:mm'),
      //   endDate.format('MMMM DD HH:mm'),
      //   isTodayBeforeEndDate,
      //   daysLeft,
      //   'BEFORE IF BLOCKS'
      // );

      if (isTodayBeforeEndDate && daysLeft >= 0) {
        // console.log(isTodayBeforeEndDate, daysLeft, 'FIRST IF');

        message =
          daysLeft === 0
            ? 'Your trial ends in less than 1 day'
            : `Your trial ends in ${daysLeft} ${
                daysLeft === 1 ? 'day' : 'days'
              }`;
      } else if (
        !isTodayBeforeEndDate &&
        daysLeft < 0 &&
        org?.subscription?.endedAt
      ) {
        // console.log(
        //   !isTodayBeforeEndDate,
        //   daysLeft,
        //   org?.subscription?.endedAt,
        //   'SECOND IF'
        // );

        const endedDate = moment(org?.subscription?.endedAt).format(
          'MMMM DD, YYYY'
        );

        message = `Your subscription ended at ${endedDate}`;
      }
    }

    return message;
  };

  const noticeMessage = defineNoticeDateMessage();

  const defineStatusLabelClassName = () => {
    const isActiveCheck =
      org?.subscription?.status === 'active' ||
      org?.subscription?.status === 'trial';

    const statusLabelClassName = `${
      isActiveCheck ? 'active ' : ''
    }gen-bill__header__details__plan-status`;

    return { statusLabelClassName };
  };

  const { statusLabelClassName } = defineStatusLabelClassName();

  const attrs = {
    wrapper: {
      className: 'gen-bill',
    },

    header: {
      wrapper: {
        className: 'gen-bill__header',
      },

      detailes: {
        wrapper: {
          className: 'gen-bill__header__details',
        },

        title: {
          className: 'gen-bill__header__details-title',
        },

        plan: {
          wrapper: {
            className: 'gen-bill__header__details__plan',
          },

          name: {
            className: 'gen-bill__header__details__plan-name',
          },

          status: {
            className: statusLabelClassName,
          },
        },

        notice: {
          className: 'gen-bill__header__details-notice',
        },
      },

      button: {
        className: `${
          isNavigationDisabledCheck ? 'disabled' : ''
        } gen-bill__header-button`,
        onClick: toggleSubscriptionModal,
      },
    },

    body: {
      wrapper: {
        className: `${
          isNavigationDisabledCheck ? 'disabled' : ''
        } gen-bill__body`,
      },
    },

    CompleteOrderModal: {
      isOpen: isNavigationDisabledCheck,
      onClick: toggleSubscriptionModal,
    },

    ManageSubscriptionModal: {
      isOpen: subscriptionModalOpen,
      onClose: toggleSubscriptionModal,
    },
  };

  const tableData = [
    { isTitle: true },
    { isPlanDetails: true },
    { value: 'Team Members', firstPlanFeature: true, secondPlanFeature: true },
    {
      value: 'Chrome Extension',
      firstPlanFeature: true,
      secondPlanFeature: true,
    },
    { value: 'Features', isSubsection: true },
    {
      value: 'Message Wizard',
      firstPlanFeature: true,
      secondPlanFeature: true,
    },
    {
      value: 'Authority Zone Position',
      firstPlanFeature: true,
      secondPlanFeature: true,
    },
    {
      value: 'Upper-Hand Analysis',
      firstPlanFeature: true,
      secondPlanFeature: true,
    },
    {
      value: `Sender's Sentiment`,
      firstPlanFeature: true,
      secondPlanFeature: true,
    },
    {
      value: 'Real-time Response Simulator',
      firstPlanFeature: true,
      secondPlanFeature: true,
    },
    {
      value: 'X- Ray Mode',
      firstPlanFeature: true,
      secondPlanFeature: true,
    },
    { value: 'Reporting & Analytics', isSubsection: true },
    {
      value: 'Performance Q Analytics',
      firstPlanFeature: true,
      secondPlanFeature: true,
    },
    {
      value: 'Team Q Analytics',
      firstPlanFeature: true,
      secondPlanFeature: true,
    },
    { value: 'Admin & Settings', isSubsection: true },
    {
      value: 'Proﬁle Management',
      firstPlanFeature: true,
      secondPlanFeature: true,
    },
    {
      value: 'User Management',
      firstPlanFeature: true,
      secondPlanFeature: true,
    },
    {
      value: 'Team Management',
      firstPlanFeature: true,
      secondPlanFeature: true,
    },
    { value: 'Support', isSubsection: true },
    {
      value: 'Help Center',
      firstPlanFeature: true,
      secondPlanFeature: true,
    },
    {
      value: 'Live Chat & Email Support',
      firstPlanFeature: true,
      secondPlanFeature: true,
    },
    {
      value: 'Custom Training & Onboarding',
      firstPlanFeature: false,
      secondPlanFeature: true,
    },
    { value: 'Integrations', isSubsection: true },
    {
      value: 'Webhooks',
      firstPlanFeature: false,
      secondPlanFeature: true,
    },
    {
      value: 'CRM & Workflow Integrations',
      firstPlanFeature: false,
      secondPlanFeature: true,
    },
  ];

  const mappedTable = (
    <div {...attrs.body.wrapper}>
      {tableData.map((el, i) => (
        <React.Fragment key={`${el}${i}`}>
          <BillingTableRow {...el} />
        </React.Fragment>
      ))}
    </div>
  );

  const statusLabel = (
    <span {...attrs.header.detailes.plan.status}>
      {org?.subscription?.status || 'inactive'}
    </span>
  );

  return (
    <div {...attrs.wrapper}>
      <div {...attrs.header.wrapper}>
        <div {...attrs.header.detailes.wrapper}>
          <span {...attrs.header.detailes.title}>Plan Details</span>
          <div {...attrs.header.detailes.plan.wrapper}>
            <span {...attrs.header.detailes.plan.name}>PRO</span>
            {statusLabel}
          </div>

          <span {...attrs.header.detailes.notice}>{noticeMessage}</span>
        </div>
        <button {...attrs.header.button}>Manage Subscribtion</button>
      </div>

      {mappedTable}

      <CompleteOrderModal {...attrs.CompleteOrderModal} />
      <ManageSubscriptionModal {...attrs.ManageSubscriptionModal} />
    </div>
  );
};
